import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiArrowRight, FiClock, FiTrendingUp } from 'react-icons/fi';

function StartScreen({ onStart, assessment }) {
  return (
    <motion.section
      className="start-screen"
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.45 }}
    >
      <div className="eyebrow"><span className="eyebrow-dot" /> BUSINESS HEALTH CHECK</div>
      <h1>{assessment?.intro || 'Is your timesheet-to-invoice process costing you money?'}</h1>
      <p className="start-intro">
        {assessment?.description || 'Answer 9 quick questions and get your personalised Health Report in about 2 minutes.'}
      </p>
      <div className="start-details">
        <span><SafeIcon icon={FiClock} aria-hidden="true" /> {assessment?.questions?.length || 9} questions</span>
        <span><SafeIcon icon={FiTrendingUp} aria-hidden="true" /> Personalised score</span>
      </div>
      <button className="primary-button start-button" type="button" onClick={onStart}>
        Start the check
        <SafeIcon icon={FiArrowRight} aria-hidden="true" />
      </button>
      <p className="reassurance">Your answers stay private. No spam.</p>
      <div className="start-orbit orbit-one" />
      <div className="start-orbit orbit-two" />
    </motion.section>
  );
}

export default StartScreen;